import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryTreeItemModel } from 'src/app/models/catalog/category-tree-item.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePage } from '../base-page';

@Component({
    selector: 'app-categories',
    templateUrl: './categories.component.html',
    styleUrls: ['./categories.component.scss'],
    standalone: false
})
export class CategoriesComponent extends BasePage implements OnInit {

  public search?: string;

  public items: Array<CategoryTreeItemModel> = [];

  public baseItemUrl: string = '';

  constructor(private mApiService: ApiService, private mRouter: Router, activatedRoute: ActivatedRoute) {
    super();

    activatedRoute.data.subscribe(r => {
      this.baseItemUrl = r['baseUrl'] ?? '/products/sort';
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  public addNew() {
    this.mRouter.navigate(['/categories/edit/new']);
  }

  public deleteCategory(id: string) {
    if (!confirm('Удалить категорию?')) {
      return;
    }

    this.isBusy = true;
    this.mApiService.delete(`/api/admin/catalog/category/${id}`).subscribe({
      next: () => {
        this.loadData();
      }, error: () => this.isBusy = false
    });
  }

  private loadData() {
    this.isBusy = true;
    this.mApiService.get<Array<CategoryTreeItemModel>>('/api/admin/catalog/category/tree').subscribe({
      next: r => {
        this.items = r;
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public override back(): void {
    this.mRouter.navigateByUrl('/categories');
  }

}
